import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Inject Bearer token from localStorage on every request (works without CORS credentials)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const DANCE_CATEGORIES = [
  "Men's Traditional",
  "Women's Traditional",
  "Fancy Dance",
  "Grass Dance",
  "Jingle Dress",
  "Chicken Dance",
  "Tiny Tots",
  "Golden Age",
  "Juniors",
  "Teens",
  "Adults",
  "Seniors",
];

export const CONTEST_TYPES = [
  "Drum contests",
  "Hand drum contests",
  "Specials",
  "Spot dances",
  "Team dance",
  "Two-step contests",
];

export const US_STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
export const CA_PROVINCES = ["AB","BC","MB","NB","NL","NS","NT","NU","ON","PE","QC","SK","YT"];
